import { MutationTree } from 'vuex';
import { IVideoLibraryState } from '@/video/library-old/store/video-library-old.types';
import { IVideo } from '@/types/Video';
import { EVideoLibraryMutation } from '@/video/library-old/store/video-library-old.constants';

export const mutations: MutationTree<IVideoLibraryState> = {
  [EVideoLibraryMutation.SetLoading](state: IVideoLibraryState, loading: boolean) {
    state.loading = loading;
  },
  [EVideoLibraryMutation.SetLoaded](state: IVideoLibraryState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EVideoLibraryMutation.SetVideos](
    state: IVideoLibraryState,
    { videos, totalCount }: { videos: IVideo[]; totalCount: number }
  ) {
    state.videos = videos;
    state.pagination.totalRows = totalCount;
  },
  [EVideoLibraryMutation.SetPagination](
    state: IVideoLibraryState,
    {
      pageMargin,
      pageSize,
      currentPage,
      totalRows,
    }: {
      pageMargin: number;
      pageSize: number;
      currentPage: number;
      totalRows: number;
    }
  ) {
    state.pagination = { pageMargin, pageSize, currentPage, totalRows };
  },

  [EVideoLibraryMutation.DeleteVideo](state: IVideoLibraryState, id: string) {
    const updatedVideos: IVideo[] = state.videos.filter(video => video.id !== id);

    state.pagination.totalRows -= 1;
    state.videos = updatedVideos;
  },
  [EVideoLibraryMutation.UpdateVideo](state: IVideoLibraryState, video: IVideo) {
    state.videos = state.videos.map((stateVideo: IVideo) => {
      return stateVideo.id === video.id ? video : stateVideo;
    });
  },
  [EVideoLibraryMutation.SetSearch](state: IVideoLibraryState, query: string) {
    state.search = query;
  },
  [EVideoLibraryMutation.SetDeleteModalVisibility](
    state: IVideoLibraryState,
    videoIdToDelete: string
  ) {
    state.videoIdDelete = videoIdToDelete;
  },
  [EVideoLibraryMutation.SetEditId](state: IVideoLibraryState, videoId: string) {
    state.videoIdEdit = videoId;
  },
  [EVideoLibraryMutation.SetState](state: IVideoLibraryState, newState: IVideoLibraryState) {
    state.loading = newState.loading;
    state.loaded = newState.loaded;
    state.videos = newState.videos;
    state.search = newState.search;
    state.pagination = newState.pagination;
    state.videoIdDelete = newState.videoIdDelete;
    state.videoIdEdit = newState.videoIdEdit;
  },
};
